import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Ponte de registro de push. O nativo entrega o token do APNs, esta página o envia ao servidor.
//
// O POST sai daqui, e não do código nativo, para aproveitar o CSRF token e o cookie de sessão
// que a página já tem — assim /push/devices continua protegido pelo CSRF padrão do Rails.
//
// Em navegador comum o Stimulus nem carrega este controller: BridgeComponent tem um
// `shouldLoad` que checa se o app nativo registrou um componente com este nome.
const STORAGE_KEY = "bratl.push";
const REREGISTER_AFTER = 7 * 24 * 60 * 60 * 1000;

export default class extends BridgeComponent {
  static component = "push";
  static values = { url: String };

  connect() {
    super.connect();
    this.send("connect", {}, ({ data }) => this.#onToken(data));
  }

  #onToken(data) {
    if (data?.token) this.#register(data.token, data.platform, data.name);
  }

  // O nativo pode responder tarde (o token do APNs chega de forma assíncrona) ou nunca, se o
  // leitor negar a permissão. Os dois casos são silenciosos de propósito.
  async #register(token, platform, name) {
    if (!this.#shouldRegister(token)) return;

    const response = await fetch(this.urlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content
      },
      body: JSON.stringify({ device: { token, platform, name } })
    });

    if (response.ok) this.#remember(token);
  }

  // Sem isto seria um POST por navegação: o `connect` roda em toda página, e o Hotwire Native
  // ainda o redispara ao restaurar uma tela do cache.
  #shouldRegister(token) {
    const { token: known, at = 0 } = this.#stored();
    return known !== token || Date.now() - at > REREGISTER_AFTER;
  }

  #stored() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch {
      return {};
    }
  }

  #remember(token) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, at: Date.now() }));
    } catch {
      // Modo privado / storage cheio: registra de novo na próxima navegação, sem quebrar nada.
    }
  }
}
